import React from "react";

/**
 * Legacy Logo component used by VendorLayout + AdminLayout sidebars
 * (both dark) and the sidebar collapsed rail.
 *
 * As of the 09/08 v3 refresh:
 *   • Dark sidebars render the INVERSE (cream+gold) master lockup on
 *     the black background directly — no CSS filter, no cream chip,
 *     no rounded plate.
 *   • Width-based sizing per spec §10/§11 (expanded: 128px, collapsed: 38px).
 *   • Height auto — the master file's natural 2.84:1 ratio is preserved.
 */
export const LOGO_URL = "/citydooh-logo-inverse.png";
export const LOGO_LIGHT_URL = "/citydooh-logo-horizontal.png";
export const ICON_URL = "/citydooh-icon.png";

/**
 * Full wordmark logo — inverse (cream + gold) by default so it drops
 * straight onto the black sidebar. Pass `light` for placements on
 * cream/white surfaces.
 */
export const Logo = ({
  size = 128,           // width in px — spec §10/§11 "125–135px"
  light = false,
  className = "",
  ...rest
}) => (
  <img
    src={light ? LOGO_LIGHT_URL : LOGO_URL}
    alt="City DOOH"
    width="1757"
    height="618"
    draggable="false"
    className={`block object-contain object-left select-none ${className}`}
    style={{ width: `${size}px`, height: "auto" }}
    {...rest}
  />
);

/**
 * Icon-only mark for collapsed sidebars, in-app watermarks, avatar slots.
 * Renders inside a square box; the source (557×602) is centred with
 * `object-contain` so proportions are preserved.
 */
export const Icon = ({ size = 38, className = "", ...rest }) => (
  <img
    src={ICON_URL}
    alt="City DOOH"
    width="557"
    height="602"
    draggable="false"
    className={`block object-contain select-none ${className}`}
    style={{ width: `${size}px`, height: "auto" }}
    {...rest}
  />
);

export default Logo;
